const concepts = [
  {
    keyword: 'INSTINCT vs CONTROL',
    text: 'Beneath every carefully constructed surface lies something untamed. The lipstick is the threshold — the moment control surrenders to desire.',
    image: 'https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/d1d2e04dc6e10e22d7db0b1c0eaaaf30.jpeg',
  },
  {
    keyword: 'Coexistence',
    text: 'The beast does not replace the woman. It lives beside her — in the same breath, the same gaze, the same red mouth. Two natures. One body. Neither wins.',
    image: 'https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/aceacdeb6e121e37c14f534ad3abc068.jpeg',
  },
  {
    keyword: 'Refined Beauty',
    text: 'Beauty is not innocent. It is constructed, deliberate, dangerous. The green eyes hold the gaze. The red mouth says nothing — and everything. This is beauty with teeth.',
    image: 'https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/ffcfc912b36ae579c1fffbc916ea7a8f.jpeg',
  },
];

export default function ConceptBody() {
  return (
    <section className="bg-[#0A0A0A] py-28 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        {concepts.map((item, i) => (
          <div
            key={i}
            className={`fade-in-up flex flex-col ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-12 md:gap-20 mb-32 last:mb-0`}
          >
            {/* Image */}
            <div className="hover-zoom w-full md:w-5/12 flex-shrink-0 bg-[#0D0D0D]" style={{ height: '560px' }}>
              <img
                src={item.image}
                alt={item.keyword}
                className={`w-full h-full object-cover object-top`}
              />
            </div>

            {/* Text */}
            <div className="flex-1">
              <p
                className="text-[#4D1815] text-xs tracking-widest mb-6"
                style={{ letterSpacing: '0.4em', fontFamily: "'Cormorant Garamond', serif" }}
              >
                0{i + 1}
              </p>
              <h2
                className="text-[#EADDCC] font-light mb-8 leading-tight"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: 'clamp(28px, 4vw, 52px)',
                  letterSpacing: '0.08em',
                }}
              >
                {item.keyword}
              </h2>
              <div className="w-12 h-px bg-[#4D1815] mb-8" />
              <p
                className="text-[#EADDCC]/60 font-light leading-relaxed"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: '18px',
                  lineHeight: 2,
                  letterSpacing: '0.03em',
                }}
              >
                {item.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
